












import Modal from "../core/Modals/Modal";
import InterventionSetupEdit from "./InterventionSetupModalPartials/InterventionSetupEdit";

export default {
    name: "InterventionSetupModal",
    components: { InterventionSetupEdit, Modal },
    props: {
        interventions: Array,
        showModal: Boolean,
    },
    methods: {
        closeModal(): void {
            this.$emit("close-modal");
        },
    },
};
